import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute, { CreatorRoute } from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Board from "@/pages/Board";
import NewRequest from "@/pages/NewRequest";
import RequestDetail from "@/pages/RequestDetail";
import Leaderboard from "@/pages/Leaderboard";
import Rewards from "@/pages/Rewards";
import Help from "@/pages/Help";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Marketplace from "@/pages/marketplace/Marketplace";
import NewTender from "@/pages/marketplace/NewTender";
import TenderDetail from "@/pages/marketplace/TenderDetail";
import OrgProfile from "@/pages/marketplace/OrgProfile";
import MarketplaceLeaderboard from "@/pages/marketplace/MarketplaceLeaderboard";
import "@/App.css";

function RedirectIfAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<RedirectIfAuth><ForgotPassword /></RedirectIfAuth>} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/login" element={<RedirectIfAuth><Login /></RedirectIfAuth>} />
          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <AppShell>
                  <Routes>
                    <Route index element={<Dashboard />} />
                    <Route path="board" element={<Board />} />
                    <Route path="requests/new" element={<CreatorRoute><NewRequest /></CreatorRoute>} />
                    <Route path="requests/:id" element={<RequestDetail />} />
                    <Route path="leaderboard" element={<Leaderboard />} />
                    <Route path="rewards" element={<Rewards />} />
                    <Route path="help" element={<Help />} />
                    <Route path="profile/:id" element={<Profile />} />
                    <Route path="marketplace" element={<Marketplace />} />
                    <Route path="marketplace/new" element={<NewTender />} />
                    <Route path="marketplace/leaderboard" element={<MarketplaceLeaderboard />} />
                    <Route path="marketplace/tenders/:id" element={<TenderDetail />} />
                    <Route path="marketplace/orgs/:orgId" element={<OrgProfile />} />
                    <Route path="admin" element={<Admin />} />
                    <Route path="*" element={<Navigate to="/app" replace />} />
                  </Routes>
                </AppShell>
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
